import { notify } from '../../../../app';

const convertTasksDetailsToCsv = (response: any): string => {
  const headers = [
    'company_name',
    'url',
    'task_id',
    'id_knowledge_base',
    'company_overview',
    'demo_url',
  ];
  const csvHeader = headers.join(',');

  const tasks = response?.tasks || [];

  const csvRows = tasks.map((task: any) => {
    const row = [
      task.company_name || '',
      task.url || '',
      task.id || '',
      task.knowledge_base_id || '',
      '',
      task.demo_url || '',
    ];

    return row
      .map(value => {
        const stringValue = String(value);
        return stringValue.includes(',') ? `"${stringValue}"` : stringValue;
      })
      .join(',');
  });

  return [csvHeader, ...csvRows].join('\n');
};

const downloadCsvFile = (
  csvContent: string,
  selectedTaskIds: string[],
  clearSelection: () => void
) => {
  const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
  const url = window.URL.createObjectURL(blob);

  const a = document.createElement('a');
  a.href = url;
  a.download = `bulk-scraping-tasks-${Date.now()}.csv`;
  document.body.appendChild(a);
  a.click();

  window.URL.revokeObjectURL(url);
  document.body.removeChild(a);

  clearSelection();
  notify.success(
    `Successfully downloaded ${selectedTaskIds.length} scraping tasks as CSV`
  );
};

export { convertTasksDetailsToCsv, downloadCsvFile };
